/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortPropertyDto } from './sortPropertyDto';
import { ExaAdapterStateV2Dto } from './exaAdapterStateV2Dto';

export interface PageDtoExaAdapterStateV2Dto {
  content?: Array<ExaAdapterStateV2Dto>;
  firstPage?: boolean;
  lastPage?: boolean;
  nextPage?: boolean;
  number?: number;
  numberOfElements?: number;
  previousPage?: boolean;
  size?: number;
  sort?: Array<SortPropertyDto>;
  totalElements?: number;
  totalPages?: number;
}
